import axios  from 'axios';

/**
 *
 * @param params params
 * @param {String} params.date_pickup Date of pickup
 * @param {String} params.pickup_day Pickup day before?
 * @returns {Promise<*>}
 */
const get = async (params) =>{
    try {
        const response = await axios.get('/reservations/delivery/pickup_hours', {params});
        return response.data;
    }catch (e){
        return  {"pickup_hours":[{"time":"7 AM","value":"07:00:00"}]};
    }
}

export default get;
